import classNames from 'classnames';
import * as React from 'react';

import * as styles from './Controls.css';
import { INDENT_TO_CLASS } from './constants';
import { IControlsProps } from './types';

export const Controls: React.FC<IControlsProps> = ({
  ruler,
  drawPolygon,
  help,
  zoomIn,
  zoomOut,
  geoLocation,
  indent = 'M',
}) => {
  return (
    <div className={classNames(styles['container'], INDENT_TO_CLASS[indent])}>
      <div className={styles['top-group']}>
        {ruler}
        {drawPolygon}
        {help}
      </div>
      <div className={styles['map-controls']}>
        {zoomIn}
        {zoomOut}
        {geoLocation && <div className={styles['geo']}>{geoLocation}</div>}
      </div>
    </div>
  );
};

Controls.displayName = 'Controls';
